<template>
    <section class="section-spacing">
        <v-container>
            <!-- Heading and Description Section -->
            <HeadingWithPara :title="`HOW WE WORK`" :paragraph="`WE WORK ON A MOST EASY AND SMART WAY,`"
                :subText="`IN JUST 4 STEP YOU CAN EASYLY GET YOUR ORDER AT YOUR PLACE.`" />

            <v-row>
                <!-- Steps Section -->
                <v-col cols="12" md="6" class="d-flex flex-column">
                    <div v-for="(step, index) in steps" :key="index" class="step-container"
                        :class="{ active: activeStep === index }">
                        <!-- Vertical Dashed Line -->
                        <div v-if="index < steps.length - 1" class="vertical-line"></div>
                        <!-- Show line only if not the last step -->

                        <!-- Step Number Circle -->
                        <div class="circle" :class="{ 'bg-primary': activeStep === index }" @click="goToStep(index)">
                            <span class="number">{{ index + 1 }}</span>
                        </div>

                        <!-- Speech Bubble -->
                        <div class="speech-bubble" :class="{ 'bg-primary': activeStep === index }"
                            @click="goToStep(index)">
                            <h5 :class="{ activeText: activeStep === index }">{{ step.title }}</h5>
                            <p :class="{ activeText: activeStep === index }">{{ step.description }}</p>
                        </div>
                        <span v-if="activeStep === index" class="arrow"></span>
                    </div>
                </v-col>

                <v-col cols="12" md="6" class="d-flex justify-center">
                    <v-img :src="steps[activeStep].image" max-width="400" width="100%" height="auto" class="d-block"
                        style="max-height: 400px; object-fit: contain;"></v-img>
                </v-col>


            </v-row>
        </v-container>
    </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import HeadingWithPara from "@/components/HomeCompoent/HeadingWithPara.vue";
import firstImage from '@/assets/images/HowWork/CUSTOMIZE.png';
import secondImage from '@/assets/images/HowWork/PLACE_ORDER.png';
import thirdImage from '@/assets/images/HowWork/ORDER_PROCESS.png';
import orderImage from '@/assets/images/HowWork/DELIVERY.png';

const steps = [
    {
        title: "SELECT / CUSTOMIZE",
        description: "Choose from our preset templates or collaborate with our expert team to create a custom design just for you.",
        image: firstImage,
    },
    {
        title: "PLACE ORDER",
        description: "Order will start, and after finalizing the design, you can confirm with a 25% advance payment.",
        image: secondImage,
    },
    {
        title: "ORDER PROCESS",
        description: "We expedite your order to meet your target date, ensuring premium quality and exceptional results every time.",
        image: thirdImage,
    },
    {
        title: "DELIVERY",
        description: "We deliver your order safely and promptly, using express service to ensure it arrives on time and in perfect condition.",
        image: orderImage,
    },
];

const activeStep = ref(0);
let interval = null;
const delayTime = 3000; // 3 seconds delay before resuming auto transitions

// Function to go to the next step
const goToNextStep = () => {
    activeStep.value = (activeStep.value + 1) % steps.length;
};

// Function to go to a specific step when clicked
const goToStep = (index) => {
    activeStep.value = index;

    clearInterval(interval);

    setTimeout(() => {
        interval = setInterval(goToNextStep, 2000);
    }, delayTime);
};

onMounted(() => {
    interval = setInterval(goToNextStep, 1500);
});

onUnmounted(() => {
    clearInterval(interval);
});
</script>


<style scoped>
/* Container for each step */
.step-container {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    position: relative;
    padding-left: 70px;
    /* Increased padding for more gap */
    cursor: pointer;
    position: relative;
    /* Position for the line */
}

/* Circle for step number */
.circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    /* Ensures the circle shape */
    background-color: #e0e0e0;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 1rem;
    border: 2px solid #bdbdbd;
    position: absolute;
    /* Position circle to the left */
    left: -0px;
    transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

/* Vertical dashed line between steps */
.vertical-line {
    position: absolute;
    left: 17px;
    top: 70px;
    width: 2px;
    height: 100%;
    border-left: 2px solid #D9D9D9;
}

/* Active state for the circle */
.step-container.active .circle {
    background-color: #1976d2;
    border-color: #1565c0;
    box-shadow: 0 0 10px 3px rgba(25, 118, 210, 0.6);
    /* Glow effect */
}

/* Active state for the speech bubble */
.step-container.active .speech-bubble {
    background-color: #f0f8ff;
    /* Light bright background */
    color: #c52929;
    /* Active color for text */
}

/* Speech bubble design */
.speech-bubble {
    background-color: #fff;
    border-radius: 8px;
    padding: 16px;
    position: relative;
    width: 100%;
    transition: background-color 0.3s ease;
}

/* Arrow pointing to the circle */
.arrow {
    position: absolute;
    top: 25px;
    left: 51px;
    transform: translateY(17px);
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-right-color: currentColor;
    background-color: transparent;
    z-index: 1;
}

/* Active state for arrow */
.step-container.active .arrow {
    color: #1976d2;
    /* Make arrow color brighter */
}

/* Active text color inside speech bubble */
.step-container.active h5,
.step-container.active p {
    color: #1976d2;
    /* Brighter text for active step */
}

/* Speech bubble text styles */
.speech-bubble h5 {
    margin: 0;
    font-size: 1.2rem;
    font-weight: bold;
    color: #333;
}

.speech-bubble p {
    margin: 8px 0 0;
    font-size: 0.9rem;
    color: #616161;
}

.step-container.active p,
.step-container.active h5 {
    color: #fff;
    /* White color when active */
}

/* Active text color */
.activeText {
    color: #eeedee;
}
</style>